module.exports = __webpack_public_path__ + "static/media/theme_icon.21b19a9a.svg";